import { LitheFC } from '@wheelbox/lithejs-engine';
import { SunIcon, MoonIcon } from '@wheelbox/lithejs-lucide';

import { createId } from '../../../../utils';
import { withSlice, updateSlice } from '../../../../state';

import { GlobalSlice } from '../../../../state/index.model';
import { APP_THEME_STORAGE_KEY } from '../../../../constants/app';

type ThemeSwitcherProps = {
  slice: string;
};

const ThemeSwitcher: LitheFC<ThemeSwitcherProps> = ({
  id = createId(),
  testId = 'theme-switcher',
  slice,
}) => {
  const { theme } = withSlice(slice) as GlobalSlice;

  const themeSwitchHandler = () => {
    const teargetTheme = theme === 'light' ? 'dark' : 'light';
    localStorage.setItem(APP_THEME_STORAGE_KEY, teargetTheme);

    updateSlice(slice, { theme: teargetTheme });
  };

  const IconComponent = theme === 'dark' ? SunIcon : MoonIcon;

  return [
    'button',
    {
      id,
      'data-testid': testId,
      type: 'button',
      class:
        'cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 rounded-sm',
      onclick: themeSwitchHandler,
      'aria-label': `Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`,
    },
    IconComponent({
      classes: [
        'h-5 w-5 hover:stroke-[var(--color-primary)] transition-colors',
        theme === 'dark' ? 'stroke-[var(--color-dark-text)]' : '',
      ],
      size: 20,
      strokeWidth: 2,
    }),
  ];
};

export default ThemeSwitcher;
